import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle,
  } from "@headlessui/react";
  import {
    ArrowLeftIcon,
    XMarkIcon,
  } from "@heroicons/react/24/outline";
  import { XCircle } from "heroicons-react";
  
  export function ErroredViewDisclosure({ showView, handleClosePanel, dialogTitle, content, redirect }) {
  
    return (
      <>
  
        <Dialog open={showView} onClose={handleClosePanel} className="relative z-50">
          <DialogBackdrop
            transition
            className="fixed inset-0 transition-opacity duration-200 ease-in-out data-[closed]:opacity-0"
          />
  
          <div className="fixed inset-x-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
                <DialogPanel
                  transition
                  className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-[closed]:translate-x-full"
                >
                  <div className="flex h-full flex-col bg-darkBg tracking-tight font-walsheim">
                    <div className="">
                      <div className="py-6 bg-darkBg">
                        <div className="flex justify-between px-4 pt-8 ">
                          <div className="flex h-7 items-center">
                            <button
                              type="button"
                              onClick={handleClosePanel}
                              className="relative text-white focus:outline-none"
                            >
                              <span className="absolute" />
                              <span className="sr-only">Cerrar</span>
                              <ArrowLeftIcon
                                aria-hidden="true"
                                className="h-6 w-6"
                              />
                            </button>
                          </div>
                          <DialogTitle>
                            <div className="text-white">{dialogTitle}</div>
                          </DialogTitle>
                          <div className="ml-3 flex h-7 items-center">
                            <button
                              type="button"
                              onClick={handleClosePanel}
                              className="relative text-white focus:outline-none"
                            >
                              <span className="absolute" />
                              <span className="sr-only">Cerrar</span>
                              <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="h-full grid content-between rounded-t-3xl bg-white p-4">
                      <div>
                        <div className="text-grayP py-4">
                          {content}
                        </div>
                        <div className="flex justify-center text-red ">
                          <XCircle className="w-20 h-auto" />
                        </div>
                      </div>
                      {/* <a className="block w-full" href={redirect}>
                        <Primary text="Terminar" />
                      </a> */}
                    </div>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </div>
        </Dialog>
      </>
    );
  }
  